import React from 'react';

export const Logo = ({ size = 'md', className = '', hideTextOnMobile = false }) => {
  const sizes = {
    sm: { icon: 36, text: 'text-lg' },
    md: { icon: 40, text: 'text-xl' },
    lg: { icon: 52, text: 'text-2xl' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} aria-label="ColiBuddy" data-testid="app-logo">
      <img
        src={`${process.env.PUBLIC_URL || ''}/images/brand/colibuddy-world-symbol.svg`}
        alt=""
        aria-hidden="true"
        width={s.icon}
        height={s.icon}
        className="block shrink-0 object-contain"
        decoding="async"
        data-testid="app-logo-symbol"
      />
      <span className={`${hideTextOnMobile ? 'hidden sm:inline ' : ''}font-["Space_Grotesk"] font-bold ${s.text} tracking-tight text-foreground`}>
        ColiBuddy
      </span>
    </div>
  );
};
